import { VehiclePowerType, VehiclePowerTypeText } from 'constants/enums/vehiclePowerType.enum';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import { IProps } from './types';
// import moment from 'moment';

const VehicalInfo: React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);

  return (
    <div className="vehical-info">
      <div className="vehical-info__title">{commonService.getNameByLng(resources, 'TID_Vehicle_registration_information')}</div>
      <div className="vehical-info__content">
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Vehicle_type')}</div>
              <div className="element__list-group-content">{`${props.VEHICLECAT_ID}-${props.VEHICLENAME}`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Brand_Model')}</div>
              <div className="element__list-group-content">{props.CAR_TYPE}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Original_license_date')}</div>
              <div className="element__list-group-content">{props.ISSUE_DATE}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Engine_number')}</div>
              <div className="element__list-group-content">{props.ENGINE_ID}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_License_plate_number')}</div>
              <div className="element__list-group-content">{props.CAR_LICENSE}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">
                {
                  props.DISPLACEMENT_UNIT && props.DISPLACEMENT_UNIT.toUpperCase() === VehiclePowerType.CubicCm
                    ? commonService.getNameByLng(resources, 'TID_CC_number')
                    : commonService.getNameByLng(resources, 'TID_HP_number')
                }
              </div>
              <div className="element__list-group-content">{props.DISPLACEMENT}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Manufacturing_date')}</div>
              <div className="element__list-group-content">{props.MANUFACTURE_TEXT}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicalInfo;
